/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { J5RegistryV1ArtifactState } from '@interxfi/types';
import { schema } from 'normalizr';

export const J5_REGISTRY_V1_ARTIFACT_STATE_ENTITY_NAME = 'j5.registry.v1.Artifact';
export const j5RegistryV1ArtifactStateEntity = new schema.Entity<J5RegistryV1ArtifactState>(J5_REGISTRY_V1_ARTIFACT_STATE_ENTITY_NAME, {}, { idAttribute: (entity: J5RegistryV1ArtifactState) => `${entity.owner}-${entity.version}-${entity.bundle}-${entity.name}` });

